import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-258910e2")
const _hoisted_1 = { class: "formDiv" }
const _hoisted_2 = { class: "table-page-search-submitButtons" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = { class: "tableDiv" }
const _hoisted_6 = { class: "tableOperator" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 赏析分类设置 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 批量歌曲导入 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 新建赏析资源 ")
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_15 = [
  _hoisted_14
]
_popScopeId()

import { ref, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { PermissionMap } from '@/utils/auth'
import { deleteAppreciation, getAppreciationList, getSortList } from '@/services/appreciation'
import { message } from 'ant-design-vue'


export default {
  setup(__props) {

const router = useRouter()

const list = ref([])
const searchBarParams = ref('')
const tableState = reactive({
  selectedRowKeys: [],
  columns: [],
  loading: true,
  pagination: {
    showSizeChanger: true,
    current: 1,
    total: 1,
    pageSize: 10,
    showTotal: total => `共${total}条`,
    showQuickJumper: true
  }
})

const formState = reactive({
  name: null,
  sort: null
})

const pageState = reactive({
  firstLoading: true,
  sortOpts: [],
  allSorts: []
})

tableState.columns = [
  {
    title: '歌曲名称',
    dataIndex: 'song_name',
    ellipsis: true
  },
  {
    title: '歌曲编码',
    dataIndex: 'song_code',
    ellipsis: true
  },
  {
    title: '所属分类',
    dataIndex: 'category_id',
    ellipsis: true,
    slots: { customRender: 'sort' }
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    ellipsis: true
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    slots: { customRender: 'action' }
  }
]

const handleSearch = () => {
  tableState.pagination.current = 1
  getList()
}

const getList = async (query) => {
  // 删除成功page没改
  tableState.loading = true
  const params = {}
  params.song_name = formState.song_name
  // params.category_id = formState.category_id?.at(-1) ?? null
  params.category_id = formState.category_id ? formState.category_id[formState.category_id.length - 1] : null
  params.per_page = tableState.pagination.pageSize
  params.page = tableState.pagination.current
  const { items, meta } = await getAppreciationList({ ...params, ...query })
  list.value = items
  tableState.pagination.total = meta.total
  tableState.pagination.current = meta.current_page
  tableState.loading = false
}

// 构造菜单树数据
const getTreeData = (pid, menus) =>
  menus
    .filter(item => item.pid === pid)
    .map(item => {
      if (menus.filter(menu => menu.pid === item.id).length === 0) {
        return { label: item.name, value: item.id }
      }
      return {
        label: item.name,
        value: item.id,
        children: getTreeData(item.id, menus)
      }
    })

const getSortData = async () => {
  const { items } = await getSortList()
  pageState.allSorts = items
  const data = getTreeData(0, items)
  pageState.sortOpts = data
}

const handleTableChange = (pag) => {
  console.log(pag)
  tableState.pagination.pageSize = pag.pageSize
  tableState.pagination.current = pag.current
  getList()
}

const handleReset = () => {
  formState.song_name = null
  formState.category_id = null
  tableState.pagination.current = 1
  getList()
}

const handleCreate = () => {
  router.push('./create/')
}

const handleJumpEdit = (id) => {
  router.push(`./edit/${id}`)
}

const handleJumpInfo = (id) => {
  router.push(`./info/${id}`)
}

const JumpConfig = () => {
  router.push('./config')
}

const handleDelete = (id) => {
  deleteAppreciation(id).then(res => {
    if (list.value.length === 1) {
      tableState.pagination.current = tableState.pagination.current === 1 ? 1 : tableState.pagination.current - 1
    }
    message.success('删除成功')
    getList()
  }).catch(err => {
    message.error('删除失败')
    console.error(err)
  })
}

onMounted(async () => {
  await Promise.all([
    getList(),
    getSortData()
  ])
  pageState.firstLoading = false
})

return (_ctx, _cache) => {
  const _component_a_skeleton = _resolveComponent("a-skeleton")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_col = _resolveComponent("a-col")
  const _component_a_cascader = _resolveComponent("a-cascader")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_row = _resolveComponent("a-row")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")
  const _component_a_tag = _resolveComponent("a-tag")
  const _component_a_table = _resolveComponent("a-table")
  const _directive_permission = _resolveDirective("permission")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(pageState).firstLoading)
      ? (_openBlock(), _createBlock(_component_a_skeleton, { key: 0 }))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              style: {"width":"100%"},
              gutter: 48
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  md: 8,
                  sm: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          onKeyup: _withKeys(getList, ["enter"]),
                          value: _unref(formState).song_name,
                          "onUpdate:value": _cache[0] || (_cache[0] = $event => (_unref(formState).song_name = $event))
                        }, null, 8, ["onKeyup", "value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  md: 8,
                  sm: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "分类" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_cascader, {
                          "change-on-select": "",
                          value: _unref(formState).category_id,
                          "onUpdate:value": _cache[1] || (_cache[1] = $event => (_unref(formState).category_id = $event)),
                          options: _unref(pageState).sortOpts,
                          placeholder: "请选择分类",
                          expandTrigger: "hover"
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, [
                      _createVNode(_component_a_button, {
                        type: "primary",
                        onClick: handleSearch
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        style: {"margin-left":"8px"},
                        onClick: handleReset
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: JumpConfig
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 512), [
            [_directive_permission, _unref(PermissionMap).APPRECIATION_CONFIG]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            onClick: _cache[2] || (_cache[2] = $event => (_unref(router).push('./import')))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 512), [
            [_directive_permission, _unref(PermissionMap).APPRECIATION_EDIT]
          ]),
          _withDirectives(_createVNode(_component_a_button, {
            type: "primary",
            onClick: handleCreate
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 512), [
            [_directive_permission, _unref(PermissionMap).APPRECIATION_EDIT]
          ])
        ]),
        _createVNode(_component_a_table, {
          dataSource: list.value,
          columns: _unref(tableState).columns,
          rowKey: "id",
          pagination: _unref(tableState).pagination,
          loading: _unref(tableState).loading,
          onChange: handleTableChange,
          scroll: { x: 1300 }
        }, {
          action: _withCtx(({ record }) => [
            _createElementVNode("span", null, [
              _createElementVNode("a", {
                onClick: $event => (handleJumpInfo(record.id))
              }, "详情", 8, _hoisted_10),
              _withDirectives(_createVNode(_component_a_divider, { type: "vertical" }, null, 512), [
                [_directive_permission, _unref(PermissionMap).APPRECIATION_EDIT]
              ]),
              _withDirectives(_createElementVNode("a", {
                onClick: $event => (handleJumpEdit(record.id))
              }, _hoisted_13, 8, _hoisted_11), [
                [_directive_permission, _unref(PermissionMap).APPRECIATION_EDIT]
              ]),
              _withDirectives(_createVNode(_component_a_divider, { type: "vertical" }, null, 512), [
                [_directive_permission, _unref(PermissionMap).APPRECIATION_DELETE]
              ]),
              _createVNode(_component_a_popconfirm, {
                title: "确定删除该资源吗?",
                "ok-text": "删除",
                "cancel-text": "取消",
                onConfirm: $event => (handleDelete(record.id))
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("a", null, _hoisted_15, 512), [
                    [_directive_permission, _unref(PermissionMap).APPRECIATION_DELETE]
                  ])
                ]),
                _: 2
              }, 1032, ["onConfirm"])
            ])
          ]),
          sort: _withCtx(({ record }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.categories, (item) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: item.id
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "loading"])
      ])
    ], 512), [
      [_vShow, !_unref(pageState).firstLoading]
    ])
  ], 64))
}
}

}